import create from 'zustand';
import produce from 'immer';

// internal
import * as BrandStoreType from '@typings/stores/initializing/brand';
import * as BrandStateType from '@typings/stores/states/brand';
import * as BrandService from '@service/brand';
import { handleError } from '@app/utils/service';
import * as storage from '@app/utils/localStorage';

const state: BrandStateType.BrandState = {
  selected: { id: '', name: '', picture: '' },
};

export const useBrandStore = create<BrandStoreType.BrandStore>((set, get) => ({
  ...state,
  onSelected: async (id, checkCacheId) => {
    if (checkCacheId && id === get().selected.id) {
      return;
    }

    try {
      set(
        produce<BrandStateType.BrandState>((state) => {
          state.selected = {
            id: '',
            name: '',
            picture: '',
          };
        }),
      );
      const { data } = await BrandService.fetchBrandWithId(id);
      if (data.success) {
        if (data.data.name === 'Winnonie') {
          storage.setIsWinnonie('true');
        } else {
          storage.clearIsWinnonie();
        }
        set(
          produce<BrandStateType.BrandState>((state) => {
            state.selected = {
              id: data.data._id,
              name: data.data.name,
              picture: data.data.picture,
            };
          }),
        );
      }
    } catch (error) {
      handleError(error);
    }
  },
}));
